export default __webpack_public_path__ + "static/media/ed2mit03tutorial01-dsaf-research-methods-v02.pptx.0d0ea193.pdf";